<template>
  <div id="AdminSms">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">sms</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Campagne</router-link>
      </li>
    </ol>
      <div class="container-fluid card-title-admin">
        <h1>Campagne</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row align-btns">
              <div class="col-lg-12">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewSms"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="TableSendSmsConfiguration"
                  :datas="tableData"
                  id="tableCustomer"
                  :onCheck="onTableCheckSms"
                  :onCheckAll="onTableCheckSms"
                  :onUncheck="onTableCheckSms"
                  :onUncheckAll="onTableCheckSms"
                  ref="tableCustomer"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-body">
              <form id="frmSendMessage">
                <div class="row">
                  <div class="col-8 text-align:center">
                    <label for="title" style="font-size: 30px;">Titolo</label>
                    <input type="text"  class="form-control" id="title" required="required" name="title" placeholder="Il titolo è un semplice identificativo ad uso interno che non verrà in alcun modo visualizzato dai destinatari finali."/>
                  </div>
                  <div class="col-4 text-align:center">
                    <label for="data-scheduler" style="font-size: 30px;">Data di invio</label>
                    <date-picker
                      placeholder="Data di invio"
                      required="required"
                      id="data-scheduler"
                      name="data-scheduler"
                      :config="configDateTime"
                    ></date-picker>
                  </div>
                </div>
                <div class="row form-textarea">
                  <div class="col-12"> 
                    <label for="text_message" style="font-size: 30px;">Testo</label>
                    <textarea
                    style="height: 200px;"
                    required="required"
                    class="form-control"
                    id="text_message"
                    name="text_message" 
                    v-on:keyup="ValueTextMessage"
                    maxlength="1000"
                    /> 
                    <div class="conteggio">
                      Caratteri: <span id="output">0</span> / <span id="output_sottr">1000</span>
                      <i class="ico-link"></i>&nbsp;&nbsp;SMS:<span id="output-count-sms">1</span> / <span id="sms-chars-smslimit">7</span>
                      <i class="ico-a"></i>&nbsp;&nbsp;Caratteri disponibili: <span id="output_caract">160</span> /  <span id="sms-chars-currentlimit">160</span>
                    </div>
                  </div>
                </div>

                <div class="row form-textarea">
                  <div class="col-12"> 
                    <h5 for="text_message">Conversione Url <font style="font-size:14px; color:#999;font-weight: lighter;font-style:italic;">(per inserire un link breve all'interno del messaggio)</font></h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 align-self-center">
                    <label for="original_url">Url originale</label>
                    <input type="text"  class="form-control" id="original_url" name="original_url" placeholder="https://www.example.com/long-url-with-many-characters/1234567890120/"/>
                  </div>
                  <div class="col-2 align-self-center text-right">
                    <button
                      style="margin-top:30px;padding: 6px;"
                      type="button"
                      class="btn btn-success"
                      data-dismiss="modal"
                      @click="formatTinyUrl"
                    ><i class="fa fa-window-minimize"></i>&nbsp;Converti e incolla</button>
                  </div>
                  <div class="col-4 align-self-center">
                    <label>Url corto</label><br>
                    <span style="font-weight: bold;" id="short-url">&nbsp;</span>
                  </div>
                </div>
              </form>
              <br><br>
              <div class="row" style="border-top:4px dashed #ededed;padding-top:25px;">
                <!-- column list number -->
                <div class="col-8">
                  <!--  tab nav dettaglio selezione numeri destinatari--->
                  <div class="tab-pane nopadding" style="box-shadow: none;" id="tabNavSelectRecipient" role="tabpanel">
                    <div class="row">
                      <div class="col-12">  
                        <h5>Seleziona i destinatari</h5>
                      </div>
                      <div class="col-12">
                        <ul class="nav nav-tabs">
                          <li class="nav-item">
                              <button 
                                id="tabAdminNumberTelephone"
                                type="button"
                                class="nav-link active"
                                data-toggle="tab"
                                href="#tabAdminNumberTelephone"
                                role="tab"
                                aria-controls="tabAdminNumberTelephone"
                                v-on:click="ontabAdminNumberTelephone"
                              >
                                <span>Singolo</span>
                              </button>
                          </li>
                          <li class="nav-item">
                              <button 
                                id="tabAdminMassiveNumberTelephone"
                                type="button"
                                class="nav-link"
                                data-toggle="tab"
                                href="#tabAdminMassiveNumberTelephone"
                                role="tab"
                                aria-controls="tabAdminMassiveNumberTelephone"
                                v-on:click="ontabAdminMassiveNumberTelephone"
                              >
                                <span>Massivo</span>
                              </button>
                          </li>
                          <li class="nav-item">
                              <button
                                id="tabAdminContact"
                                type="button"
                                class="nav-link"
                                data-toggle="tab"
                                href="#tabAdminContact"
                                role="tab"
                                aria-controls="tabAdminContact"
                                v-on:click="ontabAdminContact"
                              >
                                <span>Contatti</span>
                              </button>
                          </li>
                          <li class="nav-item">
                              <button
                                id="tabAdminGroupContact"
                                type="button"
                                class="nav-link"
                                data-toggle="tab"
                                href="#tabAdminGroupContact"
                                role="tab"
                                aria-controls="tabAdminGroupContact"
                                v-on:click="ontabAdminGroupContact"
                              >
                                <span>Gruppi</span>
                              </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> 
                  <!--  end tab nav dettaglio selezione numeri destinatari--->
                  <div class="tab-content" style="border: 0px solid #c8ced3;">
                  
                    <!--   tab  detailSingleNumberTelephone  --->  
                    <div class="card-body active tab-pane" id="detailSingleNumberTelephone" role="tabpanel" style="padding-left: 0px;padding-right: 0px;box-shadow: none;">  
                      <div class="row">  
                        <div class="col-4 align-self-center">
                          <div class="">
                            <label class="form-check-label" for="checkInsManual">
                              Inserimento Manuale
                            </label>
                          </div>
                        </div>
                        <div class="col-8 align-self-center">
                          <input type="telephone_number" class="form-control" id="telephone_number" name="telephone_number" placeholder="+393348572098"/>
                        </div>
                      </div>
                      <div class="row">  
                        <div class="col-12 text-right">
                          <button
                            style="margin-top:15px;"
                            type="button"
                            class="btn btn-success"
                            data-dismiss="modal"
                            @click="addNumberToList"
                          ><i class="fa fa-plus"></i>&nbsp;Aggiungi numero</button>
                        </div>
                      </div>
                    </div>  
                    <!--  end tab detailSingleNumberTelephone --->  


                    <!--  tab massive number  ---> 
                    <div class="card-body tab-pane" id="detailMassiveNumberTelephone" role="tabpanel" style="padding-left: 0px;padding-right: 0px;box-shadow: none;">  
                      <div class="row">  
                        <div class="col-6 align-self-center">
                          <div class="">
                            <label class="form-check-label" for="checkMassive">
                              Inserimento Massivo
                            </label>
                          </div>
                          <textarea style="width: 260px !important;height: 93px;" class="form-control" :id="'telephone_number_massive'" :name="'telephone_number_massive'"  />
                        </div>
                        <div class="col-6 align-self-center">
                          <p>Esempio:<br>
                          +393348572839<br>
                          +393388593822<br>
                          +393548502826<br>
                          +393508572839<br>
                          </p>
                        </div>
                      </div>
                      <div class="row">  
                        <div class="col-12 text-right">
                          <button
                            style="margin-top:15px;"
                            type="button"
                            class="btn btn-success"
                            data-dismiss="modal"
                            @click="addNumberMassiveToList"
                          ><i class="fa fa-plus"></i>&nbsp;Aggiungi numeri</button>
                        </div>
                      </div>
                    </div> 
                    <!--  end tab massive number---> 

                    <!--   tab  detailContactClient  ---> 
                    <div class="card-body tab-pane" id="detailContactClient" role="tabpanel" style="padding-left: 0px;padding-right: 0px;box-shadow: none;">  
                      <div class="row" style="margin-bottom: 10px;">
                        <div class="col-6">
                          <label>Seleziona Contatto</label><br>
                          <select class="custom-select user_id" style="width:100%!important;" id="user_id" name="user_id"></select>
                        </div>
                        <div class="col-3">
                          <label>Telefono</label><br>
                          <input type="text"  class="form-control telephone_number_select_contact" id="telephone_number_select_contact" name="telephone_number_select_contact">
                        </div>
                        <div class="col-3">
                          <span>Nome:&nbsp; <span id="nameContact"></span></span><br>
                          <span>Cognome:&nbsp;<span id="surnameContact"></span></span><br>
                          <span>Ragione Sociale:&nbsp;<span id="business_nameContact"></span></span>    
                        </div>
                      </div>
                       <div class="row" style="margin-bottom: 10px;">
                        <div class="col-6">
                          <label>Seleziona Utente</label><br>
                          <select class="custom-select user_id_users" style="width:100%!important;" id="user_id_users" name="user_id_users"></select>
                        </div>
                        <div class="col-3">
                          <label>Telefono</label><br>
                          <input type="text" class="form-control telephone_number_user_select_contact" id="telephone_number_user_select_contact" name="telephone_number_user_select_contact">
                        </div>
                         <div class="col-3">
                          <span>Nome:&nbsp;<span id="nameUser"></span></span><br>
                          <span>Cognome:&nbsp;<span id="surnameUser"></span></span><br>
                          <span>Ragione Sociale:&nbsp;<span id="business_nameUser"></span></span>    
                        </div>
                      </div>
                      <div class="row">  
                        <div class="col-12 text-right">
                          <button
                            style="margin-top:15px;"
                            type="button"
                            class="btn btn-success"
                            data-dismiss="modal"
                            @click="addNumberContactToList"
                          ><i class="fa fa-plus"></i>&nbsp;Aggiungi contatto</button>
                        </div>
                      </div>
                    </div> 
                    <!--  end tab detailContactClient --->

                    <!--   tab  detailGroupContactClient  ---> 
                    <div class="card-body tab-pane" id="detailGroupContactClient" role="tabpanel" style="padding-left: 0px;padding-right: 0px;box-shadow: none;">  
                      <div class="row" style="margin-bottom: 10px;">
                        <div class="col-6">
                          <label>Seleziona gruppo</label><br>
                          <select class="custom-select groupSms" style="width:100%!important;" id="groupSms" name="groupSms"></select>
                        </div>
                        <div class="col-6">
                          <div class="row">
                            <div class="col-6">
                              <label>Preview numeri</label><br>
                            </div>
                             <div class="col-6">
                              <label>Dettaglio</label><br>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 align-self-center" v-if="listNumberGroupDetailSend.length > 0" style="max-height: 250px;overflow: auto;">
                              <div v-for="listNumbersGroup in listNumberGroupDetailSend" v-bind:key="listNumbersGroup">
                                <div class="row">
                                <div class="col-6">
                                {{listNumbersGroup.telephone_number}}   
                            </div>
                               <div class="col-6">
                               <span>Nome e Cognome:&nbsp; {{listNumbersGroup.name}}{{listNumbersGroup.surname}}</span><br>
                                <span>Ragione Sociale:&nbsp; {{listNumbersGroup.business_name}}</span>
                            </div></div>
                            </div>  
                            </div>
                            <div class="col-12 text-center" v-else>
                              <p>Nessun gruppo selezionato!</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" style="margin-bottom: 10px;">
                        <div class="col-6">
                          <label>Seleziona gruppo automatico</label><br>
                          <select class="custom-select groupTelephoneQueryGroup" style="width:100%!important;" id="groupTelephoneQueryGroup" name="groupTelephoneQueryGroup"></select>
                        </div>
                        <div class="col-6">
                          <div class="row">
                            <div class="col-12">
                              <label>Preview Query</label><br>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 align-self-center" v-if="listNumbersGroupQuery.length > 0" style="max-height: 250px;overflow: auto;">
                              <div v-for="listNumberGroupQuery in listNumbersGroupQuery" v-bind:key="listNumberGroupQuery">
                                 <div class="row">
                                <div class="col-6">
                                {{ listNumberGroupQuery.telephone_number }}
                                 </div>
                               <div class="col-6">
                               <span>Nome e Cognome:&nbsp; {{listNumberGroupQuery.name}}{{listNumberGroupQuery.surname}}</span><br>
                                <span>Ragione Sociale:&nbsp; {{listNumberGroupQuery.business_name}}</span>
                            </div></div>
                              </div>
                            </div>
                            <div class="col-12 text-center" v-else>
                              <p>Nessun gruppo query selezionato!</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row">  
                        <div class="col-12 text-right">
                          <button
                            style="margin-top:15px;"
                            type="button"
                            class="btn btn-success"
                            data-dismiss="modal"
                            @click="addNumberGroupContactToList"
                          ><i class="fa fa-plus"></i>&nbsp;Aggiungi gruppo</button>
                        </div>
                      </div>
                      
                    </div> 
                    <!--  end tab detailGroupContactClient --->
                  </div>
                </div>
                <!-- end column list number -->

                <!-- column resocondo -->
                <div class="col-4" style="border-left:4px dashed #ededed;">
                  <h5>Lista</h5>
                    <span style="font-size:15px;float:right;margin-top: -30px; color:#999;font-weight: lighter;font-style:italic;">{{listNumberCount}}&nbsp;Numeri</span>
                  <div class="row">
                  <div class="col-8"> 
                   <input type="text" class="form-control" id="searchglobal" required="required" name="searchglobal" placeholder="Cerca"
                   @keyup="Search()"> 
                  </div>
                   <div class="col-4">
                     <button 
                        style="margin-top: 0px;" 
                     class="btn btn-danger"
                     @click="RemoveList()"
                     ><i class="fa fa-trash"></i> 
                     Rimuovi</button>
                   </div>
                  
                  
                  
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-12 align-self-center" v-if="listNumber.length > 0" style="max-height: 800px;overflow: auto;">
                      <div  v-for="listNumbers in listNumber" v-bind:key="listNumbers">
                       <div class="cont-single-number" v-if="listNumbers.visible">
                        {{listNumbers.numero}}&nbsp;&nbsp; ({{listNumbers.name}}&nbsp;{{listNumbers.surname}}&nbsp;-&nbsp;{{listNumbers.business_name}})
                        <i class="fa fa-trash" @click="delNumberList(listNumbers)"></i>
                      </div>
                    </div>
                    </div>
                    <div class="col-12 text-center" v-else>
                      <p>Nessun numero presente!</p>
                    </div>
                  </div>
                </div>
                <!-- end column resoconto-->
              </div>
  
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewSms"
                  ><i class="fa fa-times"></i>&nbsp; {{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="confirmSaveNewSms"
                  ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Modal impostazione iniziale ambiente, al primo caricamento-->
      <div
        class="modal fade bd-example-modal-lg"
        id="modalDettaglioCampagna"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content padding">
            <div class="modal-header text-center">
              <h2 class="modal-title w-100 font-weight-bold">
                Dettaglio campagna <i class="fa fa-times" style="float: right;margin-top: -10px;margin-right: -5px;color: #ebebeb;cursor: pointer;" @click="closePopUp()"></i>
              </h2>
            </div>
            <div class="modal-body mx-12">
              <div class="md-form mb-12">
                <div class="row">
                  <div class="col-12">
                    <h1>{{ titleDetailSend }}</h1>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p>{{ msgDetailSend }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <h2>Elenco numeri</h2>
                  </div>
                </div>
                <div class="cont-elenco-msg" v-if="listNumberDetailSend.length>0">
                  <div class="row"  v-for="singleNumber in listNumberDetailSend" v-bind:key="singleNumber.destination">
                    <div class="col-4">
                      <label>Numero</label>
                      <p>{{singleNumber.destination}}</p>
                    </div>
                    <div class="col-4">
                      <label>Stato</label>
                      <div class="div-cont-status-msg" style="background:#1FA177;" v-if="singleNumber.status == 'DLVRD'">
                        <i class="fa fa-check" aria-hidden="true"></i>&nbsp;Consegnato
                      </div>
                      <div class="div-cont-status-msg" style="background:#1FA177;" v-if="singleNumber.status == 'SENT'">
                        <i class="fa fa-paper-plane"  aria-hidden="true"></i>&nbsp;Inviato
                      </div>
                      <div class="div-cont-status-msg" style="background:#238AE6;" v-if="singleNumber.status == 'SCHEDULED'">
                        <i class="fa fa-clock-o"  aria-hidden="true"></i>&nbsp;Schedulato
                      </div>
                      <div class="div-cont-status-msg" style="background:#20a8d8;" v-if="singleNumber.status == 'WAITING'">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;In Attesa
                      </div>
                      <div class="div-cont-status-msg" style="background:#20a8d8;" v-if="singleNumber.status == 'WAIT4DLVR'">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;In Attesa di consegna
                      </div>
                      <div class="div-cont-status-msg" style="background:#F64846;" v-if="singleNumber.status == 'ERROR'">
                        <i class="fa fa-times"  aria-hidden="true"></i>&nbsp;Errore
                      </div>
                      <div class="div-cont-status-msg" style="background:#F64846;" v-if="singleNumber.status == 'KO'">
                        <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Rifiutato
                      </div>
                      <div class="div-cont-status-msg" style="background:#000;" v-if="singleNumber.status == 'BLACKLISTED'">
                        <i class="fa fa-times" aria-hidden="true"></i>&nbsp;In black list
                      </div>
                      <div class="div-cont-status-msg" style="background:#222;" v-if="singleNumber.status == 'INVALIDDST'">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i>&nbsp;Non valido
                      </div>
                      <div class="div-cont-status-msg" style="background:#F64846;" v-if="singleNumber.status == 'TIMEOUT'">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i>&nbsp;Timeout
                      </div>
                    </div>
                    <div class="col-4">
                      <label>Data di invio</label>
                      <p>{{dataDetailSend}}</p>
                    </div>
                  </div>
                </div>
                <div class="cont-elenco-msg" v-else>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h5>Nessun messaggio presente!</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end Modal impostazione iniziale ambiente, al primo caricamento -->

    </div>
  </div>
</template>
<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "AdminSms",
  components: {
    BootstrapTable,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      postalcode: dictionaryHelpers.getDictionary("PostalCode"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfiguration: [],
      detailData: {},
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newCustomer: dictionaryHelpers.getDictionary("NewCustomer"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: 'Salva campagna',
      tableConfiguration: [],
      tableCustomerResult: [],
      TableSendSmsConfiguration: [],
      DetailSendSmsConfiguration: [], 
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      length: 0,
      numero: 0,
      cont: 0,
      listNumberCount: 0,
      rowsSelected: 0,
      configDateTime: {
        format: storageData.sDateTimePickerFormat(),
        useCurrent: true,
        showClear: true,
        showClose: true
      },
      listNumber: [],
      listNumberDetailSend: [],
      listNumberGroupDetailSend: [],
      listNumbersGroupQuery: [],
      ResultContact: [],
      titleDetailSend: '',
      msgDetailSend:'',
      dataDetailSend:'',
      UsernameSMS: '',
      PasswordSMS: '',
      MittenteSMS: '',
      TokenTinyUrl: ''
    };
  },
  created() {
    var AdminSms = this;

    settingServices.getByCode("UsernameProviderMessaggi", function(result) {
      if (functionHelpers.isValued(result.message) && functionHelpers.isValued(result.message)) {
        AdminSms.UsernameSMS = result.message;
      }else{
        notificationHelpers.warning("Username per gestione SMS non impostato!<br> Inserirlo nelle gestione Impostazioni.");
      }
    });

    settingServices.getByCode("PasswordProviderMessaggi", function(result) {
      if (functionHelpers.isValued(result.message) && functionHelpers.isValued(result.message)) {
        AdminSms.PasswordSMS = result.message;
      }else{
        notificationHelpers.warning("Passwrod per gestione SMS non impostato!<br> Inserirlo nelle gestione Impostazioni.");
      }
    });

    settingServices.getByCode("SenderProviderMessaggi", function(result) {
      if (functionHelpers.isValued(result.message) && functionHelpers.isValued(result.message)) {
        AdminSms.MittenteSMS = result.message;
      }else{
        notificationHelpers.warning("Mittente per gestione SMS non impostato!<br> Inserirlo nelle gestione Impostazioni.");
      }
    });

    settingServices.getByCode("TokenAPITinyurl", function(result) {
      if (functionHelpers.isValued(result.message) && functionHelpers.isValued(result.message)) {
        AdminSms.TokenTinyUrl = result.message;
      }else{
        notificationHelpers.warning("Token per conversione URL non inserito!<br> Inserirlo nelle gestione Impostazioni.");
      }
    });

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      if (functionHelpers.isValued(result) && functionHelpers.isValued(result.data)) {
        AdminSms.TableSendSmsConfiguration = result.data.tablesConfigurations[1].tablesConfigurations;
        AdminSms.DetailSendSmsConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
      }
      AdminSms.loadTable();
    });
    
  },
  methods: {
    loadTable() {
      var AdminSms = this;
      sendSmsServices.getAll(function(result) {
        AdminSms.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    formatTinyUrl(){
      spinnerHelpers.show();
      var AdminSms = this;
      var longUrl = $('#original_url').val();
      if (functionHelpers.isValued(longUrl)) {
        var settings = {
          "url": "https://api.tinyurl.com/create?url=" + longUrl + "&domain=tiny.one",
          "method": "POST",
          "timeout": 0,
          "headers": {
            "Authorization": "Bearer " + AdminSms.TokenTinyUrl
          },
        };

        $.ajax(settings).done(function (response) {
          if (functionHelpers.isValued(response.data.tiny_url)) {
            spinnerHelpers.hide();
            $('#short-url').html(response.data.tiny_url);
            $("#text_message").val($("#text_message").val() + ' ' + response.data.tiny_url);
            AdminSms.ValueTextMessage();
          }else{
            spinnerHelpers.hide();
            notificationHelpers.error("Ops qualcosa è andato in errore, riprovare più tardi!");
          }
        });
      }else{
        spinnerHelpers.hide();
        notificationHelpers.warning("Url originale non inserio correttamente!");
      }
      
    },

    SendSmsFormatter(value, row, index, field) {
      var AdminSms = this;
      var html = '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html += '<div class="">';
      if(!row.send){
        html += '<button class="btn btn-danger" onclick="AdminSms.__vue__.confirmDeleteSmsSkebby(' + row.id + ');"><i class="fa fa-trash" title="Elimina messaggio!" /></button>';
      }
      html += '<button class="btn btn-success" onclick="AdminSms.__vue__.detailPopup(' + row.id + ');"><i class="fa fa-search" title="Visualizza storico invio" /></button>';
      html += '</div>';
      html += "</div></div>";
      return html;
    },

    executeOpenDetail(id) {
      spinnerHelpers.show();
      var AdminSms = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
        if (AdminSms.rowIdSelected == row.id) {
          AdminSms.detailData = row;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

  onChangeSelectedOptional() {
      var AdminSms = this;
      if ($("#checkInsManual").is(":checked")) {
        $("#telephone_number_massive").css("display", "inline-block");
        $("#checkMassive").css("display", "inline-block");
      }
    },
    ontabAdminGroupContact: function () {
      var AdminSms = this;
      $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function () {
        var searchParam = "";
        $("#groupSms").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/groupSms/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              console.log(dataParse.data);
               dataParse.data.unshift({html: '',id: 0,  text: "Nessuno"});
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });
      $("#groupSms").on("change", function() {
        var id = $(this).val();
        //funzione per prelievo lista contatti con il gruppo selezionato
        sendSmsServices.getListContactByGroup(id, function(response) {
          AdminSms.listNumberGroupDetailSend = [];
          if(response.data.length>0){
            for(var i=0; i<response.data.length; i++){
              AdminSms.listNumberGroupDetailSend = response.data; 
              console.log(response.data);  
            }
          }else{
            notificationHelpers.warning("Nessun numero presente nel gruppo!");
          }
        });
      }); 

 $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function () {
        var searchParam = "";
        $("#groupTelephoneQueryGroup").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/querygroupnewsletter/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data); 
              dataParse.data.unshift({html: '',id: 0,  text: "Nessuno"});
              return {
                results: dataParse.data,
              };
             
            },
          },
        });
      });

    $("#groupTelephoneQueryGroup").on("change", function() {
          var id = $(this).val();
          //funzione prelievo da lista query gruppi  
          sendSmsServices.getListTelephoneQueryGroup(id, function(response) {
          AdminSms.listNumbersGroupQuery= [];
          if(response.data.length>0){
            for(var i=0; i<response.data.length; i++){
              console.log(response.data);
              AdminSms.listNumbersGroupQuery = response.data;  
            }
          }else{
            notificationHelpers.warning("Nessun numero presente!");
          }
          });
        }); 

      $("#detailGroupContactClient").addClass("active");
      $("#detailContactClient").removeClass("active");
      $("#detailMassiveNumberTelephone").removeClass("active");
      $("#detailSingleNumberTelephone").removeClass("active");
    },
    ontabAdminContact: function () {
      var AdminSms = this;
      $.getScript(
        "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js"
      ).done(function () {
        var searchParam = "";
        $("#user_id").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/contact/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
                 dataParse.data.unshift({html: '',id: 0,  text: "Nessuno"});
              return {
                results: dataParse.data,
              };
            },
          },
        });

    var searchParam = "";
        $("#user_id_users").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
                dataParse.data.unshift({html: '',id: 0,  text: "Nessuno"});
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });
      $("#user_id").on("change", function() {
        var id = $(this).val();
        var adminSms = this; 
        sendSmsServices.getnumbertelephone(id, function(response) {
          $("#telephone_number_select_contact").val(response.data.telephone_number_select_contact);
          $("#nameContact").html(response.data.name);
          $("#surnameContact").html(response.data.surname);
          $("#business_nameContact").html(response.data.business_name);

        }); 
      }); 

       $("#user_id_users").on("change", function() {
        var id = $(this).val();
        sendSmsServices.getListContactByUser(id, function(response) {
          $("#telephone_number_user_select_contact").val(response.data.telephone_number_user_select_contact);
          $("#nameUser").html(response.data.name);
          $("#surnameUser").html(response.data.surname);
          $("#business_nameUser").html(response.data.business_name);
        }); 
      }); 
      $("#detailContactClient").addClass("active");
      $("#detailGroupContactClient").removeClass("active");
      $("#detailMassiveNumberTelephone").removeClass("active");
      $("#detailSingleNumberTelephone").removeClass("active");
    },
    addNumberContactToList: function () {
    var AdminSms = this;

    var numero = $("#telephone_number_select_contact").val().trim().replace(' ','');
    var nameContact = $("#nameContact").html().trim().replace(' ','');
    var surnameContact = $("#surnameContact").html().trim().replace(' ','');
    var business_nameContact = $("#business_nameContact").html().trim().replace(' ','');

      if(functionHelpers.isValued(numero)){
        if (numero.length < 10) 
                  {
                      notificationHelpers.warning("Attenzione, Devi inserire il numero correttamente");
                      return false;
                  }
      }
      
      if(functionHelpers.isValued(numero)){
        var arrayNumber = numero.split("\n");
        for(var i = 0;i<arrayNumber.length;i++){
          var check = false;
          for(var j = 0; j < AdminSms.listNumber.length; j++) {
              var obj = AdminSms.listNumber[j].numero;
            if(obj == arrayNumber[i]){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Numero " + arrayNumber[i] + " già presente nella lista!");
          }else{
          AdminSms.listNumber.push({numero:numero,visible:true,name:nameContact,surname:surnameContact,business_name:business_nameContact});
          }
       }
      }
      /*else{
        notificationHelpers.warning("Numero non corretto!");
      }  */
      $("#telephone_number_select_contact").html('');

      var numero1 = $("#telephone_number_user_select_contact").val().trim().replace(' ','');
      var nameUser = $("#nameUser").html().trim().replace(' ','');
      var surnameUser = $("#surnameUser").html().trim().replace(' ','');
      var business_nameUser = $("#business_nameUser").html().trim().replace(' ','');

    if(functionHelpers.isValued(numero1)){
       if (numero1.length < 10) 
              {
                  notificationHelpers.warning("Attenzione, Devi inserire il numero correttamente");
                  document.numero.focus();
                  return false;
              }
    }

       if(functionHelpers.isValued(numero1)){
        var arrayNumber1 = numero1.split("\n");
        for(var i = 0;i<arrayNumber1.length;i++){
          var check = false;
          for(var j = 0; j < AdminSms.listNumber.length; j++) {
              var obj = AdminSms.listNumber[j].numero;
            if(obj == arrayNumber1[i]){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Numero " + arrayNumber1[i] + " già presente nella lista!");
          }else{
            AdminSms.listNumber.push({numero:numero1,visible:true,name:nameUser,surname:surnameUser,business_name:business_nameUser});
          }
       }
      }
      /*else{
        notificationHelpers.warning("Numero non corretto!");
      }  */
      $("#telephone_number_select_contact").html('');

        this.listNumberCount = 0;
        AdminSms.listNumberCount = AdminSms.listNumber.length;
    },
    addNumberGroupContactToList: function () {
      var AdminSms = this;

        var arrayMassiveNumber = AdminSms.listNumberGroupDetailSend;
        for(var i = 0;i<arrayMassiveNumber.length;i++){
          if (arrayMassiveNumber[i].telephone_number.length < 10) 
              {
                  notificationHelpers.warning("Attenzione, Devi inserire il numero correttamente");
                 
              }else{
              
          var check = false;
          for(var j = 0; j < AdminSms.listNumber.length; j++) {
              var obj = AdminSms.listNumber[j].numero;
            if(obj == arrayMassiveNumber[i].telephone_number){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Numero " + arrayMassiveNumber[i].telephone_number + " già presente nella lista!");
          }else{
              AdminSms.listNumber.push({numero:arrayMassiveNumber[i].telephone_number, visible:true,name:arrayMassiveNumber[i].name,surname:arrayMassiveNumber[i].surname,business_name:arrayMassiveNumber[i].business_name});
          }
       }
      }

        var arrayNumberGroupQuery = AdminSms.listNumbersGroupQuery;
        for(var i = 0;i<arrayNumberGroupQuery.length;i++){
          if (arrayNumberGroupQuery[i].telephone_number.length < 10) 
              {
                  notificationHelpers.warning("Attenzione, Devi inserire il numero correttamente");
                 
              }else{
          var check = false;
          for(var j = 0; j < AdminSms.listNumber.length; j++) {
              var obj = AdminSms.listNumber[j].numero;
            if(obj == arrayNumberGroupQuery[i].telephone_number){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Numero " + arrayNumberGroupQuery[i].telephone_number + " già presente nella lista!");
          }else{
              AdminSms.listNumber.push({numero:arrayNumberGroupQuery[i].telephone_number, visible:true,name:arrayNumberGroupQuery[i].name,surname:arrayNumberGroupQuery[i].surname,business_name:arrayNumberGroupQuery[i].business_name});
          }
       }
       }
      

        this.listNumberCount = 0;
        AdminSms.listNumberCount = AdminSms.listNumber.length;
    },

     ontabAdminNumberTelephone: function () {
      var AdminSms = this;
      $("#detailContactClient").removeClass("active");
      $("#detailGroupContactClient").removeClass("active");
      $("#detailMassiveNumberTelephone").removeClass("active");
      $("#detailSingleNumberTelephone").addClass("active");
    },
    ontabAdminMassiveNumberTelephone: function () {
        $("#detailContactClient").removeClass("active");
        $("#detailGroupContactClient").removeClass("active");
        $("#detailMassiveNumberTelephone").addClass("active");
        $("#detailSingleNumberTelephone").removeClass("active");
    },

    onNewSms() {
      spinnerHelpers.show();
      this.detailData = {};
      this.titleDetail = this.newCustomer;
      this.rowIdSelected = 0;
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveSms() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveSms();
      }
    },

    executeSaveSms() {
      spinnerHelpers.show();
      var AdminSms = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCustomer.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        AdminSms.rowsSelected = AdminSms.rowsSelected + 1;

        postalCodeServices.update(
          rowToSave,
          function() {
            AdminSms.checkAllIsSaved();
            AdminSms.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(AdminSms.updateCompleted);
          },
          function(response) {
            AdminSms.checkAllIsSaved();
            AdminSms.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },
    addNumberToList(){
      var AdminSms = this;
      var numero = $("#telephone_number").val().trim().replace(' ','');

       if (numero.length < 10) 
              {
                  notificationHelpers.warning("Attenzione, Devi inserire il numero correttamente");
                  document.numero.focus();
                  return false;
              }

      var check = false;
      for(var i = 0; i < AdminSms.listNumber.length; i++) {
          var obj = AdminSms.listNumber[i].numero;
        if(obj == numero){ 
          check=true; 
          break;
        }   
      }
    if (check){
      notificationHelpers.warning("Numero " + numero + " già presente nella lista!");
    }else{
          AdminSms.listNumber.push({numero:numero,visible:true,name:'-',surname:'-',business_name:'-'});
    }
      $("#telephone_number").val('');   
      
        this.listNumberCount = 0;
        AdminSms.listNumberCount = AdminSms.listNumber.length;
    },

    addNumberMassiveToList(){
      var AdminSms = this;
      var massiveNumber = $("#telephone_number_massive").val();

  
      if(functionHelpers.isValued(massiveNumber)){
        var arrayMassiveNumber = massiveNumber.split("\n");
        for(var i = 0;i<arrayMassiveNumber.length;i++){
           if (arrayMassiveNumber[i].length < 10) 
              {
                  notificationHelpers.warning("Attenzione, Devi inserire il numero correttamente");                
              }else{
          var check = false;
          for(var j = 0; j < AdminSms.listNumber.length; j++) {
              var obj = AdminSms.listNumber[j].numero;
            if(obj == arrayMassiveNumber[i]){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Numero " + arrayMassiveNumber[i] + " già presente nella lista!");
          }else{
                AdminSms.listNumber.push({numero:arrayMassiveNumber[i],visible:true,name:'-',surname:'-',business_name:'-'});
          }
        }  
      }
      }else{
        notificationHelpers.warning("Numero non corretto!");
      }  
      $("#telephone_number_massive").html('');

        this.listNumberCount = 0;
        AdminSms.listNumberCount = AdminSms.listNumber.length;

    },

    delNumberList(numero){
      var AdminSms = this;
      AdminSms.listNumber = AdminSms.listNumber.filter(e => e !== numero);

      this.listNumberCount = 0;
      AdminSms.listNumberCount = AdminSms.listNumber.length;
    },

 
    ValueTextMessage(){
      var c = document.getElementById('text_message').value;
      document.getElementById('output').innerHTML = c.length;
      var sottr = 1000 - c.length;
      document.getElementById('output_sottr').innerHTML = sottr;
    
      var sms = 0;
      sms = 1 + Math.floor(c.length/160);
      document.getElementById("output-count-sms").innerHTML = sms;
      var caract = 160 * sms - c.length;
      if (caract ==160) caract=0;
       document.getElementById('output_caract').innerHTML = caract;
    },
    confirmDeleteSmsSkebby(id) {
      if (confirm('Sicuro di eliminare la programmazione del messaggio?')) {
        this.executeDeleteSmsSkebby(id);
      }
    },

    RemoveList(){
    var AdminSms = this;

    AdminSms.listNumber = [];
    //AdminSms.listNumber.pop();

    console.log(AdminSms.listNumber);
      this.listNumberCount = 0;
      AdminSms.listNumberCount = AdminSms.listNumber.length;
      spinnerHelpers.hide();
    },




    executeDeleteSmsSkebby(id){
      spinnerHelpers.show();
      var AdminSms = this;
      sendSmsServices.del(id, function(result) {
        var orderIdSkebby = result.message;
       
        // eliminazione messaggio su skebby API
        var BASEURL = 'https://api.skebby.it/API/v1.0/REST/';
        var username = AdminSms.UsernameSMS;
        var password = AdminSms.PasswordSMS;
        var user_key = '';
        var session_key = '';
        
        /* autenticazione skebby e inserimento messaggio in db selena e db skebby */
        $.ajax({
          type: 'GET',
          url: BASEURL + 'token?username=' + username + '&password=' + password,
          dataType: 'text'
        }).done(function (result) {
          var auth = result.split(';');
          user_key = auth[0];
          session_key = auth[1];

          $.ajax({
            type: 'DELETE',
            url: 'https://cors.bridged.cc/https://api.skebby.it/API/v1.0/REST/sms/' + orderIdSkebby,
            headers: {
              'user_key' : user_key,
              'Access_token' : session_key
            }
          }).done(function (resultSkebby) {
            spinnerHelpers.hide();
            AdminSms.loadTable();
            notificationHelpers.success('Eliminazione avvenuta con successo!');
          }).fail(function (response) {
            spinnerHelpers.hide();
            notificationHelpers.error("Sms non eliminato correttamente su Skebby");
          });
        }).fail(function (response) {
          spinnerHelpers.hide();
          notificationHelpers.error("Autenticazione fallita per eliminazione su Skebby");
        });
      });
    },
    closePopUp(){
      $('#modalDettaglioCampagna').modal('hide');
    },
    detailPopup(id) {
      spinnerHelpers.show();
      var adminSms = this;
    /*  $.each(adminSms.tableData, function (i, row) {
        if (id == row.id) {  
              $('#modalDettaglioCampagna').modal('show');
              spinnerHelpers.hide();
        }
      });*/

  $.each(adminSms.tableData, function (i, row) {
        if (id == row.id) {
          var BASEURL = 'https://api.skebby.it/API/v1.0/REST/';
          var username = adminSms.UsernameSMS;
          var password = adminSms.PasswordSMS;
          var user_key = '';
          var session_key = '';
          var idProvider = row.order_id_skebby;
          //getDetailSkebby
          /* autenticazione skebby e inserimento messaggio in db selena e db skebby */
          $.ajax({
            type: 'GET',
            url: BASEURL + 'token?username=' + username + '&password=' + password,
            dataType: 'text'
          }).done(function (result) {
            var auth = result.split(';');
            user_key = auth[0];
            session_key = auth[1];

            $.ajax({
              type: 'GET',
              url: "https://cors.bridged.cc/https://api.skebby.it/API/v1.0/REST/sms/" + idProvider,
              headers: { 
                'user_key': user_key, 
                'Access_token': session_key 
              }
            }).done(function (result) {
              adminSms.titleDetailSend = row.title;
              adminSms.msgDetailSend = row.text_message;
              adminSms.dataDetailSend = row.date_send_sms;
              adminSms.listNumberDetailSend = result.recipients;
              $('#modalDettaglioCampagna').modal('show');
              spinnerHelpers.hide();
            }).fail(function (response) {
              spinnerHelpers.hide();
              notificationHelpers.error("Errore prelievo info dettaglio!");
            });
          }).fail(function (response) {
            spinnerHelpers.hide();
            notificationHelpers.error("Autenticazione fallita per inserimento su Skebby");
          });
          /* end autenticazione skebby e inserimento messaggio in db selena e db skebby */
        }
      });
    },
    onTableCheckSms() {
      var countRowSelected = this.$refs.tableCustomer.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewSms() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelSms();
      }
    },

    executeCancelSms() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewSms() {
      if(functionHelpers.isValued($('#title').val()) && functionHelpers.isValued($('#data-scheduler').val())){
        if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
          this.executeSaveNewSms();
        }
      }else{
        notificationHelpers.warning("è necessario compilare tutti i campi prima di procedere!");
      }
    },

    executeSaveNewSms(id) {
      var AdminSms = this;
      
      var formatDataTime = $("#data-scheduler").val().split(' ');
      var formatData =  formatDataTime[0].split('/');
      var formatTime =  formatDataTime[1].replace(':','');
      var formatFinal = formatData[2] + formatData[1] + formatData[0] + formatTime + '00';  
      var res = AdminSms.listNumber;
      
      var resSkebby = [];

      if(AdminSms.listNumber.length> 0){
        for(var x = 0;x<AdminSms.listNumber.length;x++){
          resSkebby.push(AdminSms.listNumber[x].numero);
        }
      }

      var BASEURL = 'https://api.skebby.it/API/v1.0/REST/';
      var username = AdminSms.UsernameSMS;
      var password = AdminSms.PasswordSMS;
      var user_key = '';
      var session_key = '';

      /* autenticazione skebby e inserimento messaggio in db selena e db skebby */
       $.ajax({
        type: 'GET',
        url: BASEURL + 'token?username=' + username + '&password=' + password,
        dataType: 'text'
      }).done(function (result) {
        var auth = result.split(';');
        user_key = auth[0];
        session_key = auth[1];
        
        $.ajax({
          method: 'POST',
          url: BASEURL + 'sms',
          timeout: 0,
          headers: {
            'user_key' : user_key,
            'Access_token' : session_key,
            "Content-Type": "application/json"
          },
          data: JSON.stringify({
            "message_type": "GP", 
            "message": $("#text_message").val(), 
            "recipient": resSkebby, 
            "sender": AdminSms.MittenteSMS, 
            "scheduled_delivery_time": formatFinal, 
            "order_id": '',
            "returnCredits": true
          })
        }).done(function (resultSkebby) {
          var data = {
            id: id,
            telephone_number: $("#telephone_number").val(),
            title: $("#title").val(),
            text_message: $("#text_message").val(),
            date_send_sms: $("#data-scheduler").val(),
            res:res,
            order_id_skebby:resultSkebby.order_id 
          };
          
          sendSmsServices.insertSms(data, function (result) {
            if(result.data != ''){
              notificationHelpers.success("Sms Salvato con Successo");
              $("#tabTable").addClass("active");
              $("#tabDetail").removeClass("active");
              AdminSms.loadTable();
            }else{
              notificationHelpers.error("Errore in salvataggio!");
            }
          });

        }).fail(function (response) {
          notificationHelpers.error("Sms non salvato correttamente su Skebby");
        });

      }).fail(function (response) {
        notificationHelpers.error("Autenticazione fallita per inserimento su Skebby");
      });
      /* end autenticazione skebby e inserimento messaggio in db selena e db skebby */
    }, 

   Search() {
      var AdminSms = this;
      var searchglobal = $("#searchglobal").val();
      var res = searchglobal.toUpperCase();
    for(var i = 0; i < AdminSms.listNumber.length; i++) {
        if(AdminSms.listNumber[i].numero.match(new RegExp(searchglobal, "i")) || 
         AdminSms.listNumber[i].name.match(new RegExp(searchglobal, "i")) || 
         AdminSms.listNumber[i].surname.match(new RegExp(searchglobal, "i")) || 
         AdminSms.listNumber[i].business_name.match(new RegExp(searchglobal, "i"))){ 
              AdminSms.listNumber[i].visible= true;
        }else{
              AdminSms.listNumber[i].visible= false;
        }    
      }    
      
    /*  for(var i = 0; i < AdminSms.listNumber.length; i++) {
        if(AdminSms.listNumber[i].numero.search(res) > -1 || AdminSms.listNumber[i].name.search(res) > -1 || 
        AdminSms.listNumber[i].surname.search(res) > -1 || AdminSms.listNumber[i].business_name.search(res) > -1){ 
              AdminSms.listNumber[i].visible= true;
        }else{
              AdminSms.listNumber[i].visible= false;
        }
      }   */  
    },
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable();
      }
    }
  }
};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}

.form-textarea {
    resize: vertical;
    border: none !important;
    border-radius: 0px;
    padding-top: 25px;
    border-top:1px solid #ededed;
  }

.nav-tabs .nav-item{
  width:25%;
}
.nav {
  border: 0px;
}
.nav-tabs .nav-link{
  width:100%;
  border-radius:0;
  color:#fff;
  background:#3c4b64;
  border-bottom:3px solid #f45f00 !important;
  border:0px;
}
.nav-tabs .nav-link.active{
  background:#2A3545 !important;
}

.nav-tabs .nav-link.active span{
  color:#fff;
}

.nav-tabs>.nav-item>.nav-link:not(.active){
  background:#3c4b64  !important;
}
.cont-single-number {
    background: #f9f9f9;
    margin-bottom: 5px;
    padding: 10px;
    border-radius: 2px;
    box-shadow: 0px 2px 10px -8px rgb(0 0 0 / 70%);
    border-left: 3px solid #3C4B64;
    transition:all ease-in-out 0.25s;
}
.cont-single-number .fa-trash{
  color: #f86c6b;
  float: right;
  cursor:pointer;
  margin-top: 4px;
}
/* dettaglio sms */
.cont-elenco-msg label{
  margin-bottom:3px;
  border-bottom:3px solid #ededed;
  font-size:11px;
  width:100%;
}
.div-cont-status-msg{
    color: #fff;
    display: inline-block;
    padding: 2px 15px;
    font-size: 13px;
    border-radius: 20px;
    font-weight: bold;
    box-shadow: 0px 2px 10px -8px rgb(0 0 0 / 70%);
}

.select2 {
  height:35px!important;
}

/* end dettaglio sms */
</style>